"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rewardDefinitions = exports.COBRAND_PARTNER_MERCHANT_REWARD_NAMES = void 0;
const my_1 = require("../../my");
const rewards_1 = require("../../rewards");
const rewardAppliedWhereRule_1 = require("../rewardRules/rewardAppliedWhereRule");
const rewardConditionRule_1 = require("../rewardRules/rewardConditionRule");
const rewardLimitRule_1 = require("../rewardRules/rewardLimitRule");
const defaultBeginsOn = new Date('2025-01-01');
const rewardsDepositBundleBeginsOn = new Date('2026-08-20');
// Rewards Card category-selection promo: 7% on the customer's chosen category up to $5k lifetime (+$10k on HELOC upgrade).
const rewardsOgCategorySelectionBeginsOn = new Date('2026-09-24');
const zeroPctBaseUnlimitedUnconditionalDefinition = {
    cashbackRatio: 0,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.UNRESTRICTED,
    limitRules: [],
    conditionRules: {
        autopayConditions: undefined,
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
const onePctBaseUnlimitedUnconditionalDefinition = {
    cashbackRatio: 0.01,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.UNRESTRICTED,
    limitRules: [],
    conditionRules: {
        autopayConditions: undefined,
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
const onePointFivePctBaseUnlimitedUnconditionalDefinition = {
    cashbackRatio: 0.015,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.UNRESTRICTED,
    limitRules: [],
    conditionRules: {
        autopayConditions: undefined,
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
const twoPctBaseUnlimitedUnconditionalDefinition = {
    cashbackRatio: 0.02,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.UNRESTRICTED,
    limitRules: [],
    conditionRules: {
        autopayConditions: undefined,
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
// Base Limited Unconditional
const fivePctBaseLimitedTwentyThousandPerLifetimeUnconditionalDefinition = {
    cashbackRatio: 0.05,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.UNRESTRICTED,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.lifetime,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 20000,
        },
    ],
    conditionRules: {
        autopayConditions: undefined,
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
const threePctBaseLimitedTenThousandPerYearUnconditionalDefinition = {
    cashbackRatio: 0.03,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.UNRESTRICTED,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.year,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 10000,
        },
    ],
    conditionRules: {
        autopayConditions: undefined,
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
const tenPctBaseLimitedFifteenThousandPerLifetimeUnconditionalDefinition = {
    cashbackRatio: 0.1,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.UNRESTRICTED,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.lifetime,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 15000,
        },
    ],
    conditionRules: {
        autopayConditions: undefined,
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
// Base Unlimited Conditional Auto Pay
const twoPctBaseUnlimitedConditionalAutopayEnabledDefinition = {
    cashbackRatio: 0.02,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.UNRESTRICTED,
    limitRules: [],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.ENABLED,
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
const twoPctBaseUnlimitedConditionalAutopayStatementBalanceDefinition = {
    cashbackRatio: 0.02,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.UNRESTRICTED,
    limitRules: [],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.CATEGORY,
            autopayCategories: [my_1.AutopayCategory.STATEMENT_BALANCE],
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
const twoPctBaseUnlimitedConditionalAutopayCurrentBalanceDefinition = {
    cashbackRatio: 0.02,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.UNRESTRICTED,
    limitRules: [],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.CATEGORY,
            autopayCategories: [my_1.AutopayCategory.CURRENT_BALANCE],
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
const twoPctBaseUnlimitedConditionalAutopayCustomAmountDefinition = {
    cashbackRatio: 0.02,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.UNRESTRICTED,
    limitRules: [],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.CATEGORY,
            autopayCategories: [my_1.AutopayCategory.CUSTOM_AMOUNT],
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
const twoPctBaseUnlimitedConditionalAutopayMinimumDueDefinition = {
    cashbackRatio: 0.02,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.UNRESTRICTED,
    limitRules: [],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.CATEGORY,
            autopayCategories: [my_1.AutopayCategory.MINIMUM_DUE],
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
const twoPctBaseUnlimitedConditionalAutopayBiMonthlyCurrentBalanceDefinition = {
    cashbackRatio: 0.02,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.UNRESTRICTED,
    limitRules: [],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.CATEGORY,
            autopayCategories: [my_1.AutopayCategory.BI_MONTHLY_CURRENT_BALANCE],
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
const onePointFivePctBaseUnlimitedConditionalAutopayStatementBalanceDefinition = {
    cashbackRatio: 0.015,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.UNRESTRICTED,
    limitRules: [],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.CATEGORY,
            autopayCategories: [my_1.AutopayCategory.STATEMENT_BALANCE],
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
const onePointFivePctBaseUnlimitedConditionalAutopayCurrentBalanceDefinition = {
    cashbackRatio: 0.015,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.UNRESTRICTED,
    limitRules: [],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.CATEGORY,
            autopayCategories: [my_1.AutopayCategory.CURRENT_BALANCE],
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
const onePointFivePctBaseUnlimitedConditionalAutopayCustomAmountDefinition = {
    cashbackRatio: 0.015,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.UNRESTRICTED,
    limitRules: [],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.CATEGORY,
            autopayCategories: [my_1.AutopayCategory.CUSTOM_AMOUNT],
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
const onePointFivePctBaseUnlimitedConditionalAutopayMinimumDueDefinition = {
    cashbackRatio: 0.015,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.UNRESTRICTED,
    limitRules: [],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.CATEGORY,
            autopayCategories: [my_1.AutopayCategory.MINIMUM_DUE],
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
const onePointFivePctBaseUnlimitedConditionalAutopayBiMonthlyCurrentBalanceDefinition = {
    cashbackRatio: 0.015,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.UNRESTRICTED,
    limitRules: [],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.CATEGORY,
            autopayCategories: [my_1.AutopayCategory.BI_MONTHLY_CURRENT_BALANCE],
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
const onePctBaseUnlimitedConditionalAutopayEnabledDefinition = {
    cashbackRatio: 0.01,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.UNRESTRICTED,
    limitRules: [],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.ENABLED,
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
const onePctBaseUnlimitedConditionalAutopayStatementBalanceDefinition = {
    cashbackRatio: 0.01,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.UNRESTRICTED,
    limitRules: [],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.CATEGORY,
            autopayCategories: [my_1.AutopayCategory.STATEMENT_BALANCE],
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
const onePctBaseUnlimitedConditionalAutopayCurrentBalanceDefinition = {
    cashbackRatio: 0.01,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.UNRESTRICTED,
    limitRules: [],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.CATEGORY,
            autopayCategories: [my_1.AutopayCategory.CURRENT_BALANCE],
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
const onePctBaseUnlimitedConditionalAutopayCustomAmountDefinition = {
    cashbackRatio: 0.01,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.UNRESTRICTED,
    limitRules: [],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.CATEGORY,
            autopayCategories: [my_1.AutopayCategory.CUSTOM_AMOUNT],
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
const onePctBaseUnlimitedConditionalAutopayMinimumDueDefinition = {
    cashbackRatio: 0.01,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.UNRESTRICTED,
    limitRules: [],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.CATEGORY,
            autopayCategories: [my_1.AutopayCategory.MINIMUM_DUE],
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
const onePctBaseUnlimitedConditionalAutopayBiMonthlyCurrentBalanceDefinition = {
    cashbackRatio: 0.01,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.UNRESTRICTED,
    limitRules: [],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.CATEGORY,
            autopayCategories: [my_1.AutopayCategory.BI_MONTHLY_CURRENT_BALANCE],
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
// Base Limited Conditional Auto Pay
const threePctBaseLimitedOneThousandPerCycleConditionalAutopayEnabledDefinition = {
    cashbackRatio: 0.03,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.UNRESTRICTED,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.cycle,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 1000,
        },
    ],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.ENABLED,
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
const fivePctBaseLimitedFiveHundredPerCycleConditionalAutopayEnabledDefinition = {
    cashbackRatio: 0.05,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.UNRESTRICTED,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.cycle,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 500,
        },
    ],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.ENABLED,
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
const fivePctBaseLimitedOneThousandPerLifetimeConditionalAutopayFiveDaysAfterEnabledDefinition = {
    cashbackRatio: 0.05,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.UNRESTRICTED,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.lifetime,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 1000,
        },
    ],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.TIME_AFTER_ENABLED,
            numDaysAfterAutopayEnabled: 5,
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
const createThreePctBaseLimitedPerYearConditionalAutopayEnabledDefinition = (maxPurchaseAmountEligibleDollars) => {
    return {
        cashbackRatio: 0.03,
        appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.UNRESTRICTED,
        limitRules: [
            {
                rewardLimitType: rewards_1.RewardLimitType.year,
                amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
                maxPurchaseAmountEligibleDollars,
            },
        ],
        conditionRules: {
            autopayConditions: {
                autopayConditionType: rewardConditionRule_1.AutopayConditionRule.ENABLED,
            },
            depositBundleConditions: undefined,
        },
        triggerRules: {
            triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
        },
        beginsOn: defaultBeginsOn,
    };
};
const threePctBaseLimitedTenThousandPerYearConditionalAutopayEnabledDefinition = createThreePctBaseLimitedPerYearConditionalAutopayEnabledDefinition(10000);
const fivePctBaseLimitedTenThousandPerYearConditionalAutopayEnabledDefinition = {
    cashbackRatio: 0.05,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.UNRESTRICTED,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.year,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 10000,
        },
    ],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.ENABLED,
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: new Date('2026-07-20'),
};
/** @deprecated */
const fivePctBaseLimitedTwentyFiveThousandPerYearConditionalAutopayEnabledDefinition = {
    cashbackRatio: 0.05,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.UNRESTRICTED,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.year,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 25000,
        },
    ],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.ENABLED,
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
/** @deprecated */
const fivePctBaseLimitedFiveThousandPerCycleTwentyFiveThousandPerYearConditionalAutopayEnabledDefinition = {
    cashbackRatio: 0.05,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.UNRESTRICTED,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.year,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 25000,
        },
        {
            rewardLimitType: rewards_1.RewardLimitType.cycle,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 5000,
        },
    ],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.ENABLED,
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
const fivePctBaseLimitedTwentyFiveThousandPerYearConditionalAutopayEnabledAndRewardsDepositBundleEnrollmentActiveDefinition = {
    cashbackRatio: 0.05,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.UNRESTRICTED,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.year,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 25000,
        },
    ],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.ENABLED,
        },
        depositBundleConditions: {
            depositBundleConditionType: rewardConditionRule_1.DepositBundleConditionRule.REWARDS_DEPOSIT_BUNDLE_ENROLLMENT_ACTIVE,
        },
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: rewardsDepositBundleBeginsOn,
};
const fivePctBaseLimitedFiveThousandPerCycleTwentyFiveThousandPerYearConditionalAutopayEnabledAndRewardsDepositBundleEnrollmentActiveDefinition = {
    cashbackRatio: 0.05,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.UNRESTRICTED,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.year,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 25000,
        },
        {
            rewardLimitType: rewards_1.RewardLimitType.cycle,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 5000,
        },
    ],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.ENABLED,
        },
        depositBundleConditions: {
            depositBundleConditionType: rewardConditionRule_1.DepositBundleConditionRule.REWARDS_DEPOSIT_BUNDLE_ENROLLMENT_ACTIVE,
        },
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: rewardsDepositBundleBeginsOn,
};
const fivePctBaseLimitedSelectedMonthlyAmountPerCycleSelectedAmountPerYearConditionalAutopayEnabledAndRewardsDepositBundleEnrollmentActiveDefinition = {
    cashbackRatio: 0.05,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.UNRESTRICTED,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.year,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.REWARDS_DEPOSIT_BUNDLE_ENROLLMENT_AMOUNT,
        },
        {
            rewardLimitType: rewards_1.RewardLimitType.cycle,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.REWARDS_DEPOSIT_BUNDLE_ENROLLMENT_AMOUNT,
        },
    ],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.ENABLED,
        },
        depositBundleConditions: {
            depositBundleConditionType: rewardConditionRule_1.DepositBundleConditionRule.REWARDS_DEPOSIT_BUNDLE_ENROLLMENT_ACTIVE,
        },
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: rewardsDepositBundleBeginsOn,
};
const threePctBaseLimitedTwentyThousandPerYearConditionalAutopayEnabledDefinition = createThreePctBaseLimitedPerYearConditionalAutopayEnabledDefinition(20000);
const threePctBaseLimitedThirtyThousandPerYearConditionalAutopayEnabledDefinition = createThreePctBaseLimitedPerYearConditionalAutopayEnabledDefinition(30000);
const threePctBaseLimitedFortyThousandPerYearConditionalAutopayEnabledDefinition = createThreePctBaseLimitedPerYearConditionalAutopayEnabledDefinition(40000);
const threePctBaseLimitedFiftyThousandPerYearConditionalAutopayEnabledDefinition = createThreePctBaseLimitedPerYearConditionalAutopayEnabledDefinition(50000);
const threePctBaseLimitedSixtyThousandPerYearConditionalAutopayEnabledDefinition = createThreePctBaseLimitedPerYearConditionalAutopayEnabledDefinition(60000);
const threePctBaseLimitedSeventyThousandPerYearConditionalAutopayEnabledDefinition = createThreePctBaseLimitedPerYearConditionalAutopayEnabledDefinition(70000);
const threePctBaseLimitedEightyThousandPerYearConditionalAutopayEnabledDefinition = createThreePctBaseLimitedPerYearConditionalAutopayEnabledDefinition(80000);
const threePctBaseLimitedNinetyThousandPerYearConditionalAutopayEnabledDefinition = createThreePctBaseLimitedPerYearConditionalAutopayEnabledDefinition(90000);
const threePctBaseLimitedOneHundredThousandPerYearConditionalAutopayEnabledDefinition = createThreePctBaseLimitedPerYearConditionalAutopayEnabledDefinition(100000);
const threePctBaseLimitedOneHundredTenThousandPerYearConditionalAutopayEnabledDefinition = createThreePctBaseLimitedPerYearConditionalAutopayEnabledDefinition(110000);
const threePctBaseLimitedOneHundredTwentyThousandPerYearConditionalAutopayEnabledDefinition = createThreePctBaseLimitedPerYearConditionalAutopayEnabledDefinition(120000);
const threePctBaseLimitedOneHundredThirtyThousandPerYearConditionalAutopayEnabledDefinition = createThreePctBaseLimitedPerYearConditionalAutopayEnabledDefinition(130000);
const threePctBaseLimitedOneHundredFortyThousandPerYearConditionalAutopayEnabledDefinition = createThreePctBaseLimitedPerYearConditionalAutopayEnabledDefinition(140000);
const threePctBaseLimitedOneHundredFiftyThousandPerYearConditionalAutopayEnabledDefinition = createThreePctBaseLimitedPerYearConditionalAutopayEnabledDefinition(150000);
const threePctBaseLimitedOneHundredSixtyThousandPerYearConditionalAutopayEnabledDefinition = createThreePctBaseLimitedPerYearConditionalAutopayEnabledDefinition(160000);
const threePctBaseLimitedOneHundredSeventyThousandPerYearConditionalAutopayEnabledDefinition = createThreePctBaseLimitedPerYearConditionalAutopayEnabledDefinition(170000);
const threePctBaseLimitedOneHundredEightyThousandPerYearConditionalAutopayEnabledDefinition = createThreePctBaseLimitedPerYearConditionalAutopayEnabledDefinition(180000);
const threePctBaseLimitedOneHundredNinetyThousandPerYearConditionalAutopayEnabledDefinition = createThreePctBaseLimitedPerYearConditionalAutopayEnabledDefinition(190000);
const threePctBaseLimitedTwoHundredThousandPerYearConditionalAutopayEnabledDefinition = createThreePctBaseLimitedPerYearConditionalAutopayEnabledDefinition(200000);
const createIncrementingPctBaseLimitedPerLifetimeConditionalAutopayEnabledDefinition = ({ cashbackRatio, lifetimeLimit }) => ({
    cashbackRatio,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.UNRESTRICTED,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.lifetime,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: lifetimeLimit,
        },
    ],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.ENABLED,
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
});
const INCREMENTING_REWARD_LIFETIME_LIMIT_DOLLARS = 10000;
const fourPctBaseLimitedTenThousandPerLifetimeConditionalAutopayEnabledDefinition = createIncrementingPctBaseLimitedPerLifetimeConditionalAutopayEnabledDefinition({
    cashbackRatio: 0.04,
    lifetimeLimit: INCREMENTING_REWARD_LIFETIME_LIMIT_DOLLARS,
});
const fivePctBaseLimitedTenThousandPerLifetimeConditionalAutopayEnabledDefinition = createIncrementingPctBaseLimitedPerLifetimeConditionalAutopayEnabledDefinition({
    cashbackRatio: 0.05,
    lifetimeLimit: INCREMENTING_REWARD_LIFETIME_LIMIT_DOLLARS,
});
const sixPctBaseLimitedTenThousandPerLifetimeConditionalAutopayEnabledDefinition = createIncrementingPctBaseLimitedPerLifetimeConditionalAutopayEnabledDefinition({
    cashbackRatio: 0.06,
    lifetimeLimit: INCREMENTING_REWARD_LIFETIME_LIMIT_DOLLARS,
});
const sevenPctBaseLimitedTenThousandPerLifetimeConditionalAutopayEnabledDefinition = createIncrementingPctBaseLimitedPerLifetimeConditionalAutopayEnabledDefinition({
    cashbackRatio: 0.07,
    lifetimeLimit: INCREMENTING_REWARD_LIFETIME_LIMIT_DOLLARS,
});
const eightPctBaseLimitedTenThousandPerLifetimeConditionalAutopayEnabledDefinition = createIncrementingPctBaseLimitedPerLifetimeConditionalAutopayEnabledDefinition({
    cashbackRatio: 0.08,
    lifetimeLimit: INCREMENTING_REWARD_LIFETIME_LIMIT_DOLLARS,
});
const ninePctBaseLimitedTenThousandPerLifetimeConditionalAutopayEnabledDefinition = createIncrementingPctBaseLimitedPerLifetimeConditionalAutopayEnabledDefinition({
    cashbackRatio: 0.09,
    lifetimeLimit: INCREMENTING_REWARD_LIFETIME_LIMIT_DOLLARS,
});
const tenPctBaseLimitedTenThousandPerLifetimeConditionalAutopayEnabledDefinition = createIncrementingPctBaseLimitedPerLifetimeConditionalAutopayEnabledDefinition({
    cashbackRatio: 0.1,
    lifetimeLimit: INCREMENTING_REWARD_LIFETIME_LIMIT_DOLLARS,
});
const threePctBaseLimitedTenThousandPerYearConditionalAutopayMinimumDueOrBiMonthlyCurrentBalanceDefinition = {
    cashbackRatio: 0.03,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.UNRESTRICTED,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.year,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 10000,
        },
    ],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.CATEGORY,
            autopayCategories: [my_1.AutopayCategory.MINIMUM_DUE, my_1.AutopayCategory.BI_MONTHLY_CURRENT_BALANCE],
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
const threePctBaseLimitedOneHundredThousandPerLifetimeConditionalAutopayEnabledDefinition = {
    cashbackRatio: 0.03,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.UNRESTRICTED,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.lifetime,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 100000,
        },
    ],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.ENABLED,
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
// Specific
// Specific Home Depot Limited Unconditional
const fivePctSpecificHomeDepotLimitedOneThousandPerCycleUnconditionalDefinition = {
    cashbackRatio: 0.05,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.HOME_DEPOT,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.cycle,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 1000,
        },
    ],
    conditionRules: {
        autopayConditions: undefined,
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
const twoPctSpecificCobrandPartnerMerchantsLimitedFiveThousandPerYearUnconditionalDefinition = {
    cashbackRatio: 0.02,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.DB_MERCHANT_CODES,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.year,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 5000,
        },
    ],
    conditionRules: {
        autopayConditions: undefined,
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
const threePctSpecificCobrandPartnerMerchantsLimitedFiftyThousandPerYearConditionalAutopayEnabledDefinition = {
    cashbackRatio: 0.03,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.DB_MERCHANT_CODES,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.year,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 50_000,
        },
    ],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.ENABLED,
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
const threePctSpecificCobrandPartnerMerchantsLimitedTenThousandPerYearConditionalAutopayEnabledDefinition = {
    cashbackRatio: 0.03,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.DB_MERCHANT_CODES,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.year,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 10_000,
        },
    ],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.ENABLED,
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
exports.COBRAND_PARTNER_MERCHANT_REWARD_NAMES = [
    rewards_1.RewardName.threePctSpecificCobrandPartnerMerchantsLimitedFiftyThousandPerYearConditionalAutopayEnabled,
    rewards_1.RewardName.threePctSpecificCobrandPartnerMerchantsLimitedTenThousandPerYearConditionalAutopayEnabled,
    rewards_1.RewardName.twoPctSpecificCobrandPartnerMerchantsLimitedFiveThousandPerYearUnconditional,
];
const fivePctSpecificHomeDepotLimitedOneThousandPerCycleConditionalAutopayEnabledDefinition = {
    cashbackRatio: 0.05,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.HOME_DEPOT,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.cycle,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 1000,
        },
    ],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.ENABLED,
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
// Specific Food and Gas Related Limited Conditional Auto Pay
const sixPctSpecificGasStationsAndAutomatedFuelDispensersLimitedTenThousandPerYearConditionalAutopayEnabledDefinition = {
    cashbackRatio: 0.06,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.GAS_STATIONS_AND_AUTOMATED_FUEL_DISPENSERS,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.year,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 10000,
        },
    ],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.ENABLED,
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
const sixPctSpecificGroceriesSupermarketsAndMiscFoodStoresLimitedTenThousandPerYearConditionalAutopayEnabledDefinition = {
    cashbackRatio: 0.06,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.GROCERIES_SUPERMARKETS_AND_MISC_FOOD_STORES,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.year,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 10000,
        },
    ],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.ENABLED,
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
const sevenPctSpecificAutomatedFuelDispensersLimitedFiveThousandPerYearConditionalAutopayEnabledDefinition = {
    cashbackRatio: 0.07,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.AUTOMATED_FUEL_DISPENSERS,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.year,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 5000,
        },
    ],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.ENABLED,
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
const sevenPctSpecificGasStationsLimitedFiveThousandPerYearConditionalAutopayEnabledDefinition = {
    cashbackRatio: 0.07,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.GAS_STATIONS,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.year,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 5000,
        },
    ],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.ENABLED,
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
const sevenPctSpecificGasAndGroceriesLimitedFiveThousandPerYearConditionalAutopayEnabledDefinition = {
    cashbackRatio: 0.07,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.GAS_AND_GROCERIES,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.year,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 5000,
        },
    ],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.ENABLED,
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
const sevenPctSpecificGasAndGroceriesLimitedTenThousandPerYearConditionalAutopayEnabledDefinition = {
    cashbackRatio: 0.07,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.GAS_AND_GROCERIES,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.year,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 10000,
        },
    ],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.ENABLED,
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
const sevenPctSpecificGroceriesAndSupermarketsLimitedFiveThousandPerYearConditionalAutopayEnabledDefinition = {
    cashbackRatio: 0.07,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.GROCERIES_AND_SUPERMARKETS,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.year,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 5000,
        },
    ],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.ENABLED,
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
const sevenPctSpecificRestaurantsLimitedTenThousandPerYearConditionalAutopayEnabledDefinition = {
    cashbackRatio: 0.07,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.RESTAURANTS,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.year,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 10000,
        },
    ],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.ENABLED,
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
const fivePctSpecificStarbucksDunkinLimitedFourThousandPerYearConditionalAutopayEnabledDefinition = {
    cashbackRatio: 0.05,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.STARBUCKS_DUNKIN,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.year,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 4000,
        },
    ],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.ENABLED,
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
const fivePctSpecificGasGroceriesAndUtilitiesLimitedTenThousandPerYearConditionalAutopayEnabledDefinition = {
    cashbackRatio: 0.05,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.GAS_GROCERIES_AND_UTILITIES,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.year,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 10000,
        },
    ],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.ENABLED,
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
const sevenPctSpecificTravelLimitedFiveThousandPerLifetimeConditionalAutopayEnabledDefinition = {
    cashbackRatio: 0.07,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.TRAVEL,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.lifetime,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 5000,
        },
    ],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.ENABLED,
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: rewardsOgCategorySelectionBeginsOn,
};
const sevenPctSpecificTravelLimitedTenThousandPerLifetimeConditionalAutopayEnabledDefinition = {
    cashbackRatio: 0.07,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.TRAVEL,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.lifetime,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 10000,
        },
    ],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.ENABLED,
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: rewardsOgCategorySelectionBeginsOn,
};
const sevenPctSpecificHomeImprovementLimitedFiveThousandPerLifetimeConditionalAutopayEnabledDefinition = {
    cashbackRatio: 0.07,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.HOME_IMPROVEMENT,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.lifetime,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 5000,
        },
    ],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.ENABLED,
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: rewardsOgCategorySelectionBeginsOn,
};
const sevenPctSpecificHomeImprovementLimitedTenThousandPerLifetimeConditionalAutopayEnabledDefinition = {
    cashbackRatio: 0.07,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.HOME_IMPROVEMENT,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.lifetime,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 10000,
        },
    ],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.ENABLED,
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: rewardsOgCategorySelectionBeginsOn,
};
const sevenPctSpecificUtilitiesGasAndEvChargingLimitedFiveThousandPerLifetimeConditionalAutopayEnabledDefinition = {
    cashbackRatio: 0.07,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.UTILITIES_GAS_AND_EV_CHARGING,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.lifetime,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 5000,
        },
    ],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.ENABLED,
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: rewardsOgCategorySelectionBeginsOn,
};
const sevenPctSpecificUtilitiesGasAndEvChargingLimitedTenThousandPerLifetimeConditionalAutopayEnabledDefinition = {
    cashbackRatio: 0.07,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.UTILITIES_GAS_AND_EV_CHARGING,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.lifetime,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 10000,
        },
    ],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.ENABLED,
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: rewardsOgCategorySelectionBeginsOn,
};
const sevenPctSpecificGroceriesSupermarketsAndMiscFoodStoresLimitedFiveThousandPerLifetimeConditionalAutopayEnabledDefinition = {
    cashbackRatio: 0.07,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.GROCERIES_SUPERMARKETS_AND_MISC_FOOD_STORES,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.lifetime,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 5000,
        },
    ],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.ENABLED,
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: rewardsOgCategorySelectionBeginsOn,
};
const sevenPctSpecificGroceriesSupermarketsAndMiscFoodStoresLimitedTenThousandPerLifetimeConditionalAutopayEnabledDefinition = {
    cashbackRatio: 0.07,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.GROCERIES_SUPERMARKETS_AND_MISC_FOOD_STORES,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.lifetime,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 10000,
        },
    ],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.ENABLED,
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: rewardsOgCategorySelectionBeginsOn,
};
const sevenPctSpecificRestaurantsLimitedFiveThousandPerLifetimeConditionalAutopayEnabledDefinition = {
    cashbackRatio: 0.07,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.RESTAURANTS,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.lifetime,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 5000,
        },
    ],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.ENABLED,
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: rewardsOgCategorySelectionBeginsOn,
};
const sevenPctSpecificRestaurantsLimitedTenThousandPerLifetimeConditionalAutopayEnabledDefinition = {
    cashbackRatio: 0.07,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.RESTAURANTS,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.lifetime,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 10000,
        },
    ],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.ENABLED,
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: rewardsOgCategorySelectionBeginsOn,
};
// Specific Point of Sale Merchants Limited Unconditional
const fivePctSpecificPointOfSaleMerchantsLimitedTwentyThousandPerLifetimeUnconditionalDefinition = {
    cashbackRatio: 0.05,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.POINT_OF_SALE_MERCHANTS,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.lifetime,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 20000,
        },
    ],
    conditionRules: {
        autopayConditions: undefined,
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
// Specific Semper Fi Merchant Unlimited Unconditional
const fivePctSpecificSemperFiMerchantUnlimitedUnconditionalDefinition = {
    cashbackRatio: 0.05,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.SEMPER_FI_MERCHANT,
    limitRules: [],
    conditionRules: {
        autopayConditions: undefined,
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
// Specific Type Five Merchant Unlimited Unconditional
const fivePctSpecificTypeFiveMerchantUnlimitedUnconditionalDefinition = {
    cashbackRatio: 0.05,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.TYPE_FIVE_MERCHANT,
    limitRules: [],
    conditionRules: {
        autopayConditions: undefined,
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
// For remediation purposes.
const sixPctBaseLimitedTenThousandPerYearConditionalAutopayEnabled = {
    cashbackRatio: 0.06,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.UNRESTRICTED,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.year,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 10_000,
        },
    ],
    conditionRules: {
        autopayConditions: {
            autopayConditionType: rewardConditionRule_1.AutopayConditionRule.ENABLED,
        },
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
//TODO: Implement when converting to HOA payments to checks
const twoPctSpecificHOAPaymentsLimitedTwentyThousandPerYearUnconditionalDefinition = {
    cashbackRatio: 0.02,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.HOA_PAYMENTS,
    limitRules: [
        {
            rewardLimitType: rewards_1.RewardLimitType.year,
            amountSource: rewardLimitRule_1.RewardLimitAmountSource.FIXED,
            maxPurchaseAmountEligibleDollars: 20000,
        },
    ],
    conditionRules: {
        autopayConditions: undefined,
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_EXTERNAL_BILL,
    },
    beginsOn: defaultBeginsOn,
};
// Test Definition
const testRewardDefinition = {
    cashbackRatio: 0,
    appliedWhereRule: rewardAppliedWhereRule_1.AppliedWhereRuleNames.UNRESTRICTED,
    limitRules: [],
    conditionRules: {
        autopayConditions: undefined,
        depositBundleConditions: undefined,
    },
    triggerRules: {
        triggerType: rewards_1.RewardTrigger.ON_TRANSACTION,
    },
    beginsOn: defaultBeginsOn,
};
exports.rewardDefinitions = {
    // Test Rewards
    [rewards_1.RewardName.testRewardA]: testRewardDefinition,
    [rewards_1.RewardName.testRewardB]: testRewardDefinition,
    // Base Unlimited Unconditional
    [rewards_1.RewardName.zeroPctBaseUnlimitedUnconditional]: zeroPctBaseUnlimitedUnconditionalDefinition,
    [rewards_1.RewardName.onePctBaseUnlimitedUnconditional]: onePctBaseUnlimitedUnconditionalDefinition,
    [rewards_1.RewardName.onePointFivePctBaseUnlimitedUnconditional]: onePointFivePctBaseUnlimitedUnconditionalDefinition,
    [rewards_1.RewardName.twoPctBaseUnlimitedUnconditional]: twoPctBaseUnlimitedUnconditionalDefinition,
    // Base Limited Unconditional
    [rewards_1.RewardName.fivePctBaseLimitedTwentyThousandPerLifetimeUnconditional]: fivePctBaseLimitedTwentyThousandPerLifetimeUnconditionalDefinition,
    [rewards_1.RewardName.threePctBaseLimitedTenThousandPerYearUnconditional]: threePctBaseLimitedTenThousandPerYearUnconditionalDefinition,
    [rewards_1.RewardName.tenPctBaseLimitedFifteenThousandPerLifetimeUnconditional]: tenPctBaseLimitedFifteenThousandPerLifetimeUnconditionalDefinition,
    // Base Unlimited Conditional Auto Pay
    [rewards_1.RewardName.twoPctBaseUnlimitedConditionalAutopayEnabled]: twoPctBaseUnlimitedConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.twoPctBaseUnlimitedConditionalAutopayStatementBalance]: twoPctBaseUnlimitedConditionalAutopayStatementBalanceDefinition,
    [rewards_1.RewardName.twoPctBaseUnlimitedConditionalAutopayCurrentBalance]: twoPctBaseUnlimitedConditionalAutopayCurrentBalanceDefinition,
    [rewards_1.RewardName.twoPctBaseUnlimitedConditionalAutopayCustomAmount]: twoPctBaseUnlimitedConditionalAutopayCustomAmountDefinition,
    [rewards_1.RewardName.twoPctBaseUnlimitedConditionalAutopayMinimumDue]: twoPctBaseUnlimitedConditionalAutopayMinimumDueDefinition,
    [rewards_1.RewardName.twoPctBaseUnlimitedConditionalAutopayBiMonthlyCurrentBalance]: twoPctBaseUnlimitedConditionalAutopayBiMonthlyCurrentBalanceDefinition,
    [rewards_1.RewardName.onePointFivePctBaseUnlimitedConditionalAutopayStatementBalance]: onePointFivePctBaseUnlimitedConditionalAutopayStatementBalanceDefinition,
    [rewards_1.RewardName.onePointFivePctBaseUnlimitedConditionalAutopayCurrentBalance]: onePointFivePctBaseUnlimitedConditionalAutopayCurrentBalanceDefinition,
    [rewards_1.RewardName.onePointFivePctBaseUnlimitedConditionalAutopayCustomAmount]: onePointFivePctBaseUnlimitedConditionalAutopayCustomAmountDefinition,
    [rewards_1.RewardName.onePointFivePctBaseUnlimitedConditionalAutopayMinimumDue]: onePointFivePctBaseUnlimitedConditionalAutopayMinimumDueDefinition,
    [rewards_1.RewardName.onePointFivePctBaseUnlimitedConditionalAutopayBiMonthlyCurrentBalance]: onePointFivePctBaseUnlimitedConditionalAutopayBiMonthlyCurrentBalanceDefinition,
    [rewards_1.RewardName.onePctBaseUnlimitedConditionalAutopayEnabled]: onePctBaseUnlimitedConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.onePctBaseUnlimitedConditionalAutopayStatementBalance]: onePctBaseUnlimitedConditionalAutopayStatementBalanceDefinition,
    [rewards_1.RewardName.onePctBaseUnlimitedConditionalAutopayCurrentBalance]: onePctBaseUnlimitedConditionalAutopayCurrentBalanceDefinition,
    [rewards_1.RewardName.onePctBaseUnlimitedConditionalAutopayCustomAmount]: onePctBaseUnlimitedConditionalAutopayCustomAmountDefinition,
    [rewards_1.RewardName.onePctBaseUnlimitedConditionalAutopayMinimumDue]: onePctBaseUnlimitedConditionalAutopayMinimumDueDefinition,
    [rewards_1.RewardName.onePctBaseUnlimitedConditionalAutopayBiMonthlyCurrentBalance]: onePctBaseUnlimitedConditionalAutopayBiMonthlyCurrentBalanceDefinition,
    // Base Limited Conditional Auto Pay
    [rewards_1.RewardName.threePctBaseLimitedOneThousandPerCycleConditionalAutopayEnabled]: threePctBaseLimitedOneThousandPerCycleConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.fivePctBaseLimitedFiveHundredPerCycleConditionalAutopayEnabled]: fivePctBaseLimitedFiveHundredPerCycleConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.fivePctBaseLimitedOneThousandPerLifetimeConditionalAutopayFiveDaysAfterEnabled]: fivePctBaseLimitedOneThousandPerLifetimeConditionalAutopayFiveDaysAfterEnabledDefinition,
    [rewards_1.RewardName.threePctBaseLimitedTenThousandPerYearConditionalAutopayEnabled]: threePctBaseLimitedTenThousandPerYearConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.fivePctBaseLimitedTenThousandPerYearConditionalAutopayEnabled]: fivePctBaseLimitedTenThousandPerYearConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.fivePctBaseLimitedTwentyFiveThousandPerYearConditionalAutopayEnabled]: fivePctBaseLimitedTwentyFiveThousandPerYearConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.fivePctBaseLimitedFiveThousandPerCycleTwentyFiveThousandPerYearConditionalAutopayEnabled]: fivePctBaseLimitedFiveThousandPerCycleTwentyFiveThousandPerYearConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.fivePctBaseLimitedTwentyFiveThousandPerYearConditionalAutopayEnabledAndRewardsDepositBundleEnrollmentActive]: fivePctBaseLimitedTwentyFiveThousandPerYearConditionalAutopayEnabledAndRewardsDepositBundleEnrollmentActiveDefinition,
    [rewards_1.RewardName.fivePctBaseLimitedFiveThousandPerCycleTwentyFiveThousandPerYearConditionalAutopayEnabledAndRewardsDepositBundleEnrollmentActive]: fivePctBaseLimitedFiveThousandPerCycleTwentyFiveThousandPerYearConditionalAutopayEnabledAndRewardsDepositBundleEnrollmentActiveDefinition,
    [rewards_1.RewardName.fivePctBaseLimitedSelectedMonthlyAmountPerCycleSelectedAmountPerYearConditionalAutopayEnabledAndRewardsDepositBundleEnrollmentActive]: fivePctBaseLimitedSelectedMonthlyAmountPerCycleSelectedAmountPerYearConditionalAutopayEnabledAndRewardsDepositBundleEnrollmentActiveDefinition,
    [rewards_1.RewardName.threePctBaseLimitedTwentyThousandPerYearConditionalAutopayEnabled]: threePctBaseLimitedTwentyThousandPerYearConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.threePctBaseLimitedThirtyThousandPerYearConditionalAutopayEnabled]: threePctBaseLimitedThirtyThousandPerYearConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.threePctBaseLimitedFortyThousandPerYearConditionalAutopayEnabled]: threePctBaseLimitedFortyThousandPerYearConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.threePctBaseLimitedFiftyThousandPerYearConditionalAutopayEnabled]: threePctBaseLimitedFiftyThousandPerYearConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.threePctBaseLimitedSixtyThousandPerYearConditionalAutopayEnabled]: threePctBaseLimitedSixtyThousandPerYearConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.threePctBaseLimitedSeventyThousandPerYearConditionalAutopayEnabled]: threePctBaseLimitedSeventyThousandPerYearConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.threePctBaseLimitedEightyThousandPerYearConditionalAutopayEnabled]: threePctBaseLimitedEightyThousandPerYearConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.threePctBaseLimitedNinetyThousandPerYearConditionalAutopayEnabled]: threePctBaseLimitedNinetyThousandPerYearConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.threePctBaseLimitedOneHundredThousandPerYearConditionalAutopayEnabled]: threePctBaseLimitedOneHundredThousandPerYearConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.threePctBaseLimitedOneHundredTenThousandPerYearConditionalAutopayEnabled]: threePctBaseLimitedOneHundredTenThousandPerYearConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.threePctBaseLimitedOneHundredTwentyThousandPerYearConditionalAutopayEnabled]: threePctBaseLimitedOneHundredTwentyThousandPerYearConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.threePctBaseLimitedOneHundredThirtyThousandPerYearConditionalAutopayEnabled]: threePctBaseLimitedOneHundredThirtyThousandPerYearConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.threePctBaseLimitedOneHundredFortyThousandPerYearConditionalAutopayEnabled]: threePctBaseLimitedOneHundredFortyThousandPerYearConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.threePctBaseLimitedOneHundredFiftyThousandPerYearConditionalAutopayEnabled]: threePctBaseLimitedOneHundredFiftyThousandPerYearConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.threePctBaseLimitedOneHundredSixtyThousandPerYearConditionalAutopayEnabled]: threePctBaseLimitedOneHundredSixtyThousandPerYearConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.threePctBaseLimitedOneHundredSeventyThousandPerYearConditionalAutopayEnabled]: threePctBaseLimitedOneHundredSeventyThousandPerYearConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.threePctBaseLimitedOneHundredEightyThousandPerYearConditionalAutopayEnabled]: threePctBaseLimitedOneHundredEightyThousandPerYearConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.threePctBaseLimitedOneHundredNinetyThousandPerYearConditionalAutopayEnabled]: threePctBaseLimitedOneHundredNinetyThousandPerYearConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.threePctBaseLimitedTwoHundredThousandPerYearConditionalAutopayEnabled]: threePctBaseLimitedTwoHundredThousandPerYearConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.fourPctBaseLimitedTenThousandPerLifetimeConditionalAutopayEnabled]: fourPctBaseLimitedTenThousandPerLifetimeConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.fivePctBaseLimitedTenThousandPerLifetimeConditionalAutopayEnabled]: fivePctBaseLimitedTenThousandPerLifetimeConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.sixPctBaseLimitedTenThousandPerLifetimeConditionalAutopayEnabled]: sixPctBaseLimitedTenThousandPerLifetimeConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.sevenPctBaseLimitedTenThousandPerLifetimeConditionalAutopayEnabled]: sevenPctBaseLimitedTenThousandPerLifetimeConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.eightPctBaseLimitedTenThousandPerLifetimeConditionalAutopayEnabled]: eightPctBaseLimitedTenThousandPerLifetimeConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.ninePctBaseLimitedTenThousandPerLifetimeConditionalAutopayEnabled]: ninePctBaseLimitedTenThousandPerLifetimeConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.tenPctBaseLimitedTenThousandPerLifetimeConditionalAutopayEnabled]: tenPctBaseLimitedTenThousandPerLifetimeConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.threePctBaseLimitedTenThousandPerYearConditionalAutopayMinimumDueOrBiMonthlyCurrentBalance]: threePctBaseLimitedTenThousandPerYearConditionalAutopayMinimumDueOrBiMonthlyCurrentBalanceDefinition,
    [rewards_1.RewardName.threePctBaseLimitedOneHundredThousandPerLifetimeConditionalAutopayEnabled]: threePctBaseLimitedOneHundredThousandPerLifetimeConditionalAutopayEnabledDefinition,
    // Specific
    // Specific Home Depot Limited Unconditional
    [rewards_1.RewardName.fivePctSpecificHomeDepotLimitedOneThousandPerCycleUnconditional]: fivePctSpecificHomeDepotLimitedOneThousandPerCycleUnconditionalDefinition,
    [rewards_1.RewardName.fivePctSpecificHomeDepotLimitedOneThousandPerCycleConditionalAutopayEnabled]: fivePctSpecificHomeDepotLimitedOneThousandPerCycleConditionalAutopayEnabledDefinition,
    // Specific Cobrand Partner Merchants Limited Unconditional
    [rewards_1.RewardName.twoPctSpecificCobrandPartnerMerchantsLimitedFiveThousandPerYearUnconditional]: twoPctSpecificCobrandPartnerMerchantsLimitedFiveThousandPerYearUnconditionalDefinition,
    [rewards_1.RewardName.threePctSpecificCobrandPartnerMerchantsLimitedFiftyThousandPerYearConditionalAutopayEnabled]: threePctSpecificCobrandPartnerMerchantsLimitedFiftyThousandPerYearConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.threePctSpecificCobrandPartnerMerchantsLimitedTenThousandPerYearConditionalAutopayEnabled]: threePctSpecificCobrandPartnerMerchantsLimitedTenThousandPerYearConditionalAutopayEnabledDefinition,
    // Specific Food or Gas Related Limited Conditional Auto Pay
    [rewards_1.RewardName.sixPctSpecificGasStationsAndAutomatedFuelDispensersLimitedTenThousandPerYearConditionalAutopayEnabled]: sixPctSpecificGasStationsAndAutomatedFuelDispensersLimitedTenThousandPerYearConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.sixPctSpecificGroceriesSupermarketsAndMiscFoodStoresLimitedTenThousandPerYearConditionalAutopayEnabled]: sixPctSpecificGroceriesSupermarketsAndMiscFoodStoresLimitedTenThousandPerYearConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.sevenPctSpecificAutomatedFuelDispensersLimitedFiveThousandPerYearConditionalAutopayEnabled]: sevenPctSpecificAutomatedFuelDispensersLimitedFiveThousandPerYearConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.sevenPctSpecificGasStationsLimitedFiveThousandPerYearConditionalAutopayEnabled]: sevenPctSpecificGasStationsLimitedFiveThousandPerYearConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.sevenPctSpecificGasAndGroceriesLimitedFiveThousandPerYearConditionalAutopayEnabled]: sevenPctSpecificGasAndGroceriesLimitedFiveThousandPerYearConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.sevenPctSpecificGasAndGroceriesLimitedTenThousandPerYearConditionalAutopayEnabled]: sevenPctSpecificGasAndGroceriesLimitedTenThousandPerYearConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.sevenPctSpecificGroceriesAndSupermarketsLimitedFiveThousandPerYearConditionalAutopayEnabled]: sevenPctSpecificGroceriesAndSupermarketsLimitedFiveThousandPerYearConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.sevenPctSpecificRestaurantsLimitedTenThousandPerYearConditionalAutopayEnabled]: sevenPctSpecificRestaurantsLimitedTenThousandPerYearConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.fivePctSpecificStarbucksDunkinLimitedFourThousandPerYearConditionalAutopayEnabled]: fivePctSpecificStarbucksDunkinLimitedFourThousandPerYearConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.fivePctSpecificGasGroceriesAndUtilitiesLimitedTenThousandPerYearConditionalAutopayEnabled]: fivePctSpecificGasGroceriesAndUtilitiesLimitedTenThousandPerYearConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.sevenPctSpecificTravelLimitedFiveThousandPerLifetimeConditionalAutopayEnabled]: sevenPctSpecificTravelLimitedFiveThousandPerLifetimeConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.sevenPctSpecificTravelLimitedTenThousandPerLifetimeConditionalAutopayEnabled]: sevenPctSpecificTravelLimitedTenThousandPerLifetimeConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.sevenPctSpecificHomeImprovementLimitedFiveThousandPerLifetimeConditionalAutopayEnabled]: sevenPctSpecificHomeImprovementLimitedFiveThousandPerLifetimeConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.sevenPctSpecificHomeImprovementLimitedTenThousandPerLifetimeConditionalAutopayEnabled]: sevenPctSpecificHomeImprovementLimitedTenThousandPerLifetimeConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.sevenPctSpecificUtilitiesGasAndEvChargingLimitedFiveThousandPerLifetimeConditionalAutopayEnabled]: sevenPctSpecificUtilitiesGasAndEvChargingLimitedFiveThousandPerLifetimeConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.sevenPctSpecificUtilitiesGasAndEvChargingLimitedTenThousandPerLifetimeConditionalAutopayEnabled]: sevenPctSpecificUtilitiesGasAndEvChargingLimitedTenThousandPerLifetimeConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.sevenPctSpecificGroceriesSupermarketsAndMiscFoodStoresLimitedFiveThousandPerLifetimeConditionalAutopayEnabled]: sevenPctSpecificGroceriesSupermarketsAndMiscFoodStoresLimitedFiveThousandPerLifetimeConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.sevenPctSpecificGroceriesSupermarketsAndMiscFoodStoresLimitedTenThousandPerLifetimeConditionalAutopayEnabled]: sevenPctSpecificGroceriesSupermarketsAndMiscFoodStoresLimitedTenThousandPerLifetimeConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.sevenPctSpecificRestaurantsLimitedFiveThousandPerLifetimeConditionalAutopayEnabled]: sevenPctSpecificRestaurantsLimitedFiveThousandPerLifetimeConditionalAutopayEnabledDefinition,
    [rewards_1.RewardName.sevenPctSpecificRestaurantsLimitedTenThousandPerLifetimeConditionalAutopayEnabled]: sevenPctSpecificRestaurantsLimitedTenThousandPerLifetimeConditionalAutopayEnabledDefinition,
    // Specific Point of Sale Merchants Limited Unconditional
    [rewards_1.RewardName.fivePctSpecificPointOfSaleMerchantsLimitedTwentyThousandPerLifetimeUnconditional]: fivePctSpecificPointOfSaleMerchantsLimitedTwentyThousandPerLifetimeUnconditionalDefinition,
    // Specific Semper Fi Merchant Unlimited Unconditional
    [rewards_1.RewardName.fivePctSpecificSemperFiMerchantUnlimitedUnconditional]: fivePctSpecificSemperFiMerchantUnlimitedUnconditionalDefinition,
    // Specific Type Five Merchant Unlimited Unconditional
    [rewards_1.RewardName.fivePctSpecificTypeFiveMerchantUnlimitedUnconditional]: fivePctSpecificTypeFiveMerchantUnlimitedUnconditionalDefinition,
    // Specific HOA Payments Limited Unconditional
    [rewards_1.RewardName.twoPctSpecificHOAPaymentsLimitedTwentyThousandPerYearUnconditional]: twoPctSpecificHOAPaymentsLimitedTwentyThousandPerYearUnconditionalDefinition,
    // For remediation purposes.
    [rewards_1.RewardName.sixPctBaseLimitedTenThousandPerYearConditionalAutopayEnabled]: sixPctBaseLimitedTenThousandPerYearConditionalAutopayEnabled,
};
